export const betTypes = {
    teamGoal: "teamGoal",
    handicap: "handicap",
    overUnder: "overUnder",
    winLoseHandicap: "winLoseHandicap",
};

export const viewTypes = {
    selectLeague: "selectLeague",
    chronological: "chronological",
    viewLeague: "viewLeague",
};

export const singleOrMultiOptions = { single: "single", multi: "multi" };

export const navOptions = {
    favorites: 0,
    all: 1,
    soccer: 2,
    baseball: 3,
    basketball: 4,
    volleyball: 5,
    iceHockey: 6,
    tennis: 7,
    handball: 8,
    ufc: 9,
};

export const matchTypes = {live: 'live', upcoming:'upcoming'}